export var GallectionSourceType;
(function(GallectionSourceType) {
    GallectionSourceType["FEATURED_GALLERY"] = "featured_gallery";
    GallectionSourceType["NEWEST"] = "newest";
    GallectionSourceType["GALLERY"] = "gallery";
    GallectionSourceType["COLLECTION"] = "collection";
    GallectionSourceType["PRIVATE_COLLECTION"] = "private_collection";
    GallectionSourceType["ADOPTABLE_BOUGHT"] = "adoptable_bought";
    GallectionSourceType["ADOPTABLE_FOR_SALE"] = "adoptable_for_sale";
})(GallectionSourceType || (GallectionSourceType = {}));
export var ExhibitionistWidgetType;
(function(ExhibitionistWidgetType) {
    ExhibitionistWidgetType["TALL"] = "tall";
    ExhibitionistWidgetType["STRIP"] = "strip";
    ExhibitionistWidgetType["STRIP_SHORT"] = "strip_short";
})(ExhibitionistWidgetType || (ExhibitionistWidgetType = {}));

//# sourceMappingURL=types.js.map